import React from 'react';
import Node from './Node';
import useLegend from './useLegend';
var defaultStyle = {
  position: 'absolute',
  top: '0px',
  right: '0px'
}; // @ts-ignore

var Legend = function Legend(props) {
  var _props$bindType = props.bindType,
      bindType = _props$bindType === void 0 ? 'node' : _props$bindType,
      sortKey = props.sortKey,
      children = props.children,
      style = props.style;

  var _useLegend = useLegend({
    bindType: bindType,
    sortKey: sortKey
  }),
      dataMap = _useLegend.dataMap,
      options = _useLegend.options;

  return /*#__PURE__*/React.createElement("div", {
    className: "graphin-components-legend",
    // @ts-ignore
    style: Object.assign(Object.assign({}, defaultStyle), style)
  }, children({
    bindType: bindType,
    sortKey: sortKey,
    // @ts-ignore
    dataMap: dataMap,
    // @ts-ignore
    options: options
  }));
};

Legend.Node = Node;
export default Legend;